import React from 'react';
import Box from '@mui/material/Box';
function PrimaryTabPanel(props) {
  const { children, value, id, ...other } = props;
  return (
    <Box
      role="tabpanel"
      hidden={value !== id}
      id={`simple-tabpanel-${id}`}
      aria-labelledby={`simple-tab-${id}`}
      {...other}
    >
      {value === id && <Box>{children}</Box>}
    </Box>
  );
}

export default PrimaryTabPanel;